export var masterFirebaseConfig = {
  apiKey: "AIzaSyCjyD65wwD2md4VjgQIzc_sk7ahFbjSbCc",
  authDomain: "poll-1b51a.firebaseapp.com",
  databaseURL: "https://poll-1b51a.firebaseio.com",
  projectId: "poll-1b51a",
  storageBucket: "poll-1b51a.appspot.com",
  messagingSenderId: "282190199692"
};



// WEBPACK FOOTER //
// ./src/app/api-keys.ts